import {Stack, Typography} from '@mui/material';
import React, {Fragment} from 'react';

import {BeneficiaryCard, CTAButtonFixed, MainFooter, StyledGrid} from 'presentation/components';
import {ContactCard} from 'presentation/components/ContactCard';
import {Loading} from 'presentation/components/Loading/Loading';
import {usePersonalData} from 'presentation/hooks';
import {useMediaQueries} from 'presentation/pages/private/hooks';
import {translations} from 'presentation/translations-new';
import {RefundTaggingEnum} from 'main/analytics/gaTagsEnum';
import {RequestPreviewSummary} from '../RequestPreviewSummary';
import {CustomContainer, StyledBox, StyledFooterContainer} from './styles';
import {ConferenceProps} from './types';

const {finishRequest} = translations['pt-br'].privateFlow.refund.conferencePage;
const {requestLabel, beneficiaryData} = translations['pt-br'].commons;

export const Conference = ({handleNextStep, isLoading}: ConferenceProps) => {
	const {isMobile} = useMediaQueries();
	const {currentEmail, currentPhone} = usePersonalData();

	return (
		<Fragment>
			<CustomContainer>
				<StyledGrid.Root spacing={2}>
					<StyledGrid.Item md={12} lg={8}>
						<Stack gap={2}>
							<Typography variant="subtitle2" color="text.secondary">
								{requestLabel}
							</Typography>
							<StyledBox>
								<RequestPreviewSummary canChangeInfos showFiles showRequestNumber />
							</StyledBox>
						</Stack>
					</StyledGrid.Item>

					<StyledGrid.Item md={12} lg={4}>
						<Stack gap={2}>
							<Typography variant="subtitle2" color="text.secondary">
								{beneficiaryData}
							</Typography>

							<BeneficiaryCard shouldShowAnsPlanRegister={false} />
							<ContactCard
								user={{
									cellphone: currentPhone,
									email: currentEmail,
								}}
							/>
						</Stack>
					</StyledGrid.Item>

					<StyledGrid.Item md={12} lg={8}>
						<CTAButtonFixed.Root justifyContent="space-between">
							<Stack
								flex={1}
								gap={1}
								justifyContent="flex-end"
								flexDirection={isMobile ? 'column' : 'row'}>
								<CTAButtonFixed.Action
									data-tag-id={
										RefundTaggingEnum.CLICK_FINALIZAR_SOLICITACAO_PREVIA_REEMBOLSO
									}
									size="large"
									onClick={handleNextStep}
									variant="contained"
									fullWidth={isMobile}
									endIcon={
										isLoading ? <Loading size={20} color="inherit" /> : null
									}>
									{finishRequest}
								</CTAButtonFixed.Action>
							</Stack>
						</CTAButtonFixed.Root>
					</StyledGrid.Item>
				</StyledGrid.Root>
			</CustomContainer>
			<StyledFooterContainer>
				<MainFooter />
			</StyledFooterContainer>
		</Fragment>
	);
};
